import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [filter, setFilter] = useState("pending");
  const load = () => {
    const q = filter === "all" ? "" : `?status=${filter}`;
    api.get(`/admin/coupons${q}`).then((r) => setCoupons(r.data));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);
  const approve = async (id) => { await api.post(`/admin/coupons/${id}/approve`); toast.success("Approved"); load(); };
  const reject = async (id) => { await api.post(`/admin/coupons/${id}/reject`); toast.success("Rejected"); load(); };
  return (
    <div data-testid="admin-coupons">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <h2 className="font-display text-3xl font-semibold tracking-tight">Coupons</h2>
          <p className="text-sm text-muted-foreground mt-1">Approve, reject or audit coupons.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          {["pending", "approved", "rejected", "all"].map((f) => (
            <button key={f} onClick={() => setFilter(f)} className={`px-3 py-1.5 rounded-full text-xs font-semibold uppercase tracking-widest border ${filter === f ? "bg-foreground text-background border-foreground" : "border-border hover:bg-secondary"}`} data-testid={`filter-coupon-${f}`}>{f}</button>
          ))}
        </div>
      </div>
      <div className="pf-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/40 text-left text-xs uppercase tracking-widest text-muted-foreground">
            <tr>
              <th className="px-5 py-3">Coupon</th>
              <th className="px-5 py-3">Discount</th>
              <th className="px-5 py-3">Code</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {coupons.map((c) => (
              <tr key={c.id} className="border-t border-border" data-testid={`ac-row-${c.id}`}>
                <td className="px-5 py-3 font-medium">{c.title}</td>
                <td className="px-5 py-3">{c.discount_value}{c.discount_type === "percent" ? "%" : ""}</td>
                <td className="px-5 py-3 font-mono">{c.code || "—"}</td>
                <td className="px-5 py-3"><span className={`pf-chip ${c.status === "approved" ? "bg-[color:var(--pf-mint)] text-black" : c.status === "rejected" ? "bg-destructive text-white" : "bg-secondary"}`}>{c.status}</span></td>
                <td className="px-5 py-3 text-right space-x-1">
                  {c.status !== "approved" && <button onClick={() => approve(c.id)} className="text-xs font-semibold px-3 py-1 rounded-full bg-foreground text-background" data-testid={`approve-coupon-${c.id}`}>Approve</button>}
                  {c.status !== "rejected" && <button onClick={() => reject(c.id)} className="text-xs font-semibold px-3 py-1 rounded-full border border-border" data-testid={`reject-coupon-${c.id}`}>Reject</button>}
                </td>
              </tr>
            ))}
            {coupons.length === 0 && <tr><td colSpan={5} className="px-5 py-8 text-center text-muted-foreground">No coupons.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
